var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQualityManagementicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6163 2.79932H31.0297C29.5555 1.12295 27.383 0.0595703 24.9621 0.0595703H16.9281C14.5072 0.0595703 12.3346 1.12295 10.8604 2.79932H5.27386C2.81279 2.79932 0.810547 4.77461 0.810547 7.20244V45.6564C0.810547 48.0843 2.81279 50.0596 5.27386 50.0596H36.6163C39.0773 50.0596 41.0796 48.0843 41.0796 45.6564V7.20244C41.0796 4.77451 39.0773 2.79932 36.6163 2.79932ZM16.9281 2.99502H24.9621C27.2609 2.99502 29.17 4.51016 29.7973 6.51748H12.0928C12.7191 4.51367 14.6257 2.99502 16.9281 2.99502ZM38.104 45.6564C38.104 46.4657 37.4366 47.1241 36.6163 47.1241H5.27386C4.45351 47.1241 3.78609 46.4657 3.78609 45.6564V7.20244C3.78609 6.39316 4.45351 5.73477 5.27386 5.73477H9.22598C9.01125 6.44863 8.89411 7.20352 8.89411 7.98525C8.89411 8.7958 9.56024 9.45293 10.3819 9.45293H31.5083C32.3299 9.45293 32.996 8.7958 32.996 7.98525C32.996 7.20352 32.8789 6.44863 32.6642 5.73477H36.6163C37.4366 5.73477 38.104 6.39316 38.104 7.20244V45.6564Z",
    fill: "url(#paint0_linear_2132_699)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6105 29.2244L11.4224 31.3828L10.8874 30.855C10.3065 30.2818 9.36445 30.2818 8.78342 30.855C8.2024 31.4282 8.2024 32.3575 8.78342 32.9306L10.3704 34.4962C10.9513 35.0693 11.8934 35.0694 12.4744 34.4962L15.7144 31.2999C16.2954 30.7267 16.2954 29.7974 15.7144 29.2243C15.1334 28.6511 14.1914 28.6511 13.6105 29.2244Z",
    fill: "url(#paint1_linear_2132_699)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.955 30.3923H19.9536C19.1319 30.3923 18.4658 31.0495 18.4658 31.86C18.4658 32.6706 19.1319 33.3277 19.9536 33.3277H31.955C32.7766 33.3277 33.4427 32.6706 33.4427 31.86C33.4427 31.0495 32.7766 30.3923 31.955 30.3923Z",
    fill: "url(#paint2_linear_2132_699)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6105 37.6392L11.4224 39.7976L10.8874 39.2698C10.3065 38.6966 9.36445 38.6966 8.78342 39.2698C8.2024 39.843 8.2024 40.7723 8.78342 41.3454L10.3704 42.911C10.9513 43.4841 11.8934 43.4842 12.4744 42.911L15.7144 39.7147C16.2954 39.1415 16.2954 38.2122 15.7144 37.6391C15.1334 37.0659 14.1914 37.0659 13.6105 37.6392Z",
    fill: "url(#paint3_linear_2132_699)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.955 38.8071H19.9536C19.1319 38.8071 18.4658 39.4643 18.4658 40.2748C18.4658 41.0854 19.1319 41.7425 19.9536 41.7425H31.955C32.7766 41.7425 33.4427 41.0854 33.4427 40.2748C33.4427 39.4643 32.7766 38.8071 31.955 38.8071Z",
    fill: "url(#paint4_linear_2132_699)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7821 23.6022L28.3837 19.0628V19.2377C28.3837 20.0482 29.0498 20.7054 29.8715 20.7054C30.6931 20.7054 31.3593 20.0482 31.3593 19.2377C31.3593 15.086 31.3662 15.4726 31.3422 15.3086C31.237 14.5905 30.6129 14.0516 29.871 14.0518H26.1025C25.2808 14.0518 24.6147 14.7089 24.6147 15.5194C24.6147 16.33 25.2808 16.9871 26.1025 16.9871H26.2797L22.7302 20.4888L18.2278 16.0472C17.6469 15.4739 16.7048 15.4739 16.1238 16.0472L10.7678 21.331C10.1868 21.9041 10.1868 22.8334 10.7678 23.4065C11.3487 23.9798 12.2908 23.9798 12.8718 23.4065L17.1758 19.1606L21.6782 23.6022C22.2591 24.1754 23.2012 24.1755 23.7821 23.6022Z",
    fill: "url(#paint5_linear_2132_699)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2132_699",
    x1: 20.9451,
    y1: 0.0595703,
    x2: 20.9451,
    y2: 50.0596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2132_699",
    x1: 12.2489,
    y1: 28.7944,
    x2: 12.2489,
    y2: 34.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2132_699",
    x1: 25.9543,
    y1: 30.3923,
    x2: 25.9543,
    y2: 33.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2132_699",
    x1: 12.2489,
    y1: 37.2092,
    x2: 12.2489,
    y2: 43.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2132_699",
    x1: 25.9543,
    y1: 38.8071,
    x2: 25.9543,
    y2: 41.7425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2132_699",
    x1: 20.8461,
    y1: 14.0518,
    x2: 20.8461,
    y2: 24.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityManagementicon);
export default __webpack_public_path__ + "static/media/QualityManagementicon.531368a2b017c18e5f0a0e3f41db7993.svg";
export { ForwardRef as ReactComponent };